import { render, staticRenderFns } from "./StaffAccept.vue?vue&type=template&id=08bf7660&scoped=true&"
import script from "./StaffAccept.vue?vue&type=script&lang=js&"
export * from "./StaffAccept.vue?vue&type=script&lang=js&"
import style0 from "./StaffAccept.vue?vue&type=style&index=0&id=08bf7660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf7660",
  null
  
)

export default component.exports